import { render, staticRenderFns } from "./dash-buttons.vue?vue&type=template&id=7d985d07&scoped=true"
import script from "./dash-buttons.vue?vue&type=script&lang=ts"
export * from "./dash-buttons.vue?vue&type=script&lang=ts"
import style0 from "./dash-buttons.vue?vue&type=style&index=0&id=7d985d07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d985d07",
  null
  
)

export default component.exports